<template>
  <div id="list_contacts" class="container">
    <table class="table table-light" border="1">
      <thead>
        <tr>
          <th>Tên khách hàng</th>
          <th>Email</th>
          <th>Số điện thoại</th>
          <th>Câu hỏi</th>
          <th>Ngày tạo</th>
        </tr>
      </thead>
      <tbody >
        <tr v-for="contact in list_contacts">
          <td>{{contact.name}}</td>
          <td>{{contact.email}}</td>
          <td>{{contact.phone_number}}</td>
          <td>{{contact.question}}</td>
          <td>{{contact.created_at}}</td>          
        </tr>
      </tbody>
    </table>
    <base-pagination      
      :pageCount="pagination_contacts.total_page"
      :value="current_page"
      @input="pagination_contacts.current_page = $event"
    ></base-pagination>
  </div>
</template>
<script>
  import {mapState, mapActions, mapGetter} from 'vuex';
  export default{
    components:{    
    },
    data: function(){
      return{  
      }
      
    },
    created: function(){
      this.$store.dispatch('vuex_admin/get_list_contacts',1)
    },
    computed: {
      ...mapState('vuex_admin',[
        'list_contacts'
      ]),
      ...mapState('vuex_admin',{
        pagination_contacts: state => state.pagination_contacts,
        current_page: state => state.pagination_contacts.current_page
      }) 
    },
    watch: {
      current_page(new_value, old_value){
        if (old_value != undefined){
          this.$store.dispatch('vuex_admin/get_list_contacts', new_value)
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  @import "./list_contacts.scss"
</style>


// WEBPACK FOOTER //
// src/views/components/Admin/ListContacts.vue